import { TbArrowDownRight, TbArrowRightBar, TbArrowUpRight } from "react-icons/tb";
import "./IndicatorCard.scss";
import numeral from "numeral";

const IndicatorCard = ({ cardTitle, periodTitle, currency, amountShort, amountPerc, amountActual }) => {
    return (
        <div className="single-stat">
            <div className="single-stat-toolbar">
                <span className="single-stat-title">{cardTitle}</span>
                <span className="single-stat-period">{periodTitle}</span>
            </div>

            <div className="single-stat-wrapper">
                <span className="single-stat-figure-short">{amountShort || "0.00"}</span>
                <div>
                    {amountPerc > 0 && <span className="single-stat-indicator up">{`${amountPerc}%`} <TbArrowUpRight /></span>}
                    {amountPerc === 0 && <span className="single-stat-indicator same"> {`${amountPerc}%`} <TbArrowRightBar /></span>}
                    {amountPerc < 0 && <span className="single-stat-indicator down"> {`${amountPerc}%`} <TbArrowDownRight /></span>}
                </div>
            </div>
            <span className="single-stat-figure-actual">{currency} {numeral(amountActual || 0).format("0,0.00")} </span>
        </div>
    )
}

export default IndicatorCard